export const AUTH_ACTIONS = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGOUT: 'LOGOUT'
};

export const ORDER_ACTIONS = {
  FETCH_ORDERS_REQUEST: 'FETCH_ORDERS_REQUEST',
  FETCH_ORDERS_SUCCESS: 'FETCH_ORDERS_SUCCESS',
  FETCH_ORDERS_FAILURE: 'FETCH_ORDERS_FAILURE',
  FETCH_ORDER_REQUEST: 'FETCH_ORDER_REQUEST',
  FETCH_ORDER_SUCCESS: 'FETCH_ORDER_SUCCESS',
  FETCH_ORDER_FAILURE: 'FETCH_ORDER_FAILURE',
  UPDATE_ORDER_REQUEST: 'UPDATE_ORDER_REQUEST',
  UPDATE_ORDER_SUCCESS: 'UPDATE_ORDER_SUCCESS',
  UPDATE_ORDER_FAILURE: 'UPDATE_ORDER_FAILURE'
};

export const LOAD_ACTIONS = {
  FETCH_LOAD_REQUEST: 'FETCH_LOAD_REQUEST',
  FETCH_LOAD_SUCCESS: 'FETCH_LOAD_SUCCESS',
  FETCH_LOAD_FAILURE: 'FETCH_LOAD_FAILURE',
  CREATE_LOAD_REQUEST: 'CREATE_LOAD_REQUEST',
  CREATE_LOAD_SUCCESS: 'CREATE_LOAD_SUCCESS',
  CREATE_LOAD_FAILURE: 'CREATE_LOAD_FAILURE'
}; 